// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"V3-z","displaySixCardTiles":"W3-z"};